<!-- <div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->
  <div class="modal-body" style="text-decoration-line: none;">
    <h4>{{ message }}</h4>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()" style="margin-right: 10px;" *ngIf="button3rdEnable">{{ button3rdText }}</button>
    <button type="button" class="btn btn-danger" (click)="decline()" style="margin-right: 5px;">{{ btnCancelText }}</button>
    <button type="button" class="btn btn-primary" (click)="accept()">{{ btnOkText }}</button>
  </div>